import { space, Tag } from "@waldner-laboreinrichtungen/component-system";
import { t } from "i18next";
import type { FC } from "react";
import styledComponent from "styled-components";

import { ReactComponent as LoginIcon } from "../../public/material-icons/login.svg";

const TagContent = styledComponent.span`
  display: inline-flex;
  align-items: center;
  gap: ${space(1)};
  svg {
    width: ${space(4)};
    height: ${space(4)};
    fill: currentColor;
  }
`;

/** "Extern" chip for functions mounted from another device (Figma 5208-28188). */
export const ExternTag: FC = () => (
  <Tag minor variant="neutral">
    <TagContent>
      <LoginIcon /> {t("channel.external")}
    </TagContent>
  </Tag>
);
